import { render, staticRenderFns } from "./StartRedEnvelope.vue?vue&type=template&id=558c5523&scoped=true&"
import script from "./StartRedEnvelope.vue?vue&type=script&lang=js&"
export * from "./StartRedEnvelope.vue?vue&type=script&lang=js&"
import style0 from "./StartRedEnvelope.vue?vue&type=style&index=0&id=558c5523&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558c5523",
  null
  
)

export default component.exports